import i18n from '../../i18n';

const roundDecimals = (value, decimals = 0) => {
  return Math.round(value * 10 ** decimals) / 10 ** decimals;
};

// NOTE: this is a function so that the labels are translated dynamically
export const getKpiRatingConfigs = () => ({
  co2: {
    label: i18n.t('kpi.fields.netCo2eEmission'),
    unit: i18n.t('kpi.unit.tonsPerYear'),
    getValue: value => roundDecimals(8000 - value * 4000),
  },
  customerSatisfaction: {
    label: i18n.t('kpi.fields.customerSatisfaction'),
    unit: i18n.t('ui.symbol.percentage'),
    getValue: value => roundDecimals(70 + value * 26, 1),
  },
  employeeHappiness: {
    label: i18n.t('kpi.fields.employeeHappiness'),
    unit: i18n.t('ui.symbol.percentage'),
    getValue: value => roundDecimals(70 + value * 26),
  },
  energy: {
    label: i18n.t('kpi.fields.energyConsumption'),
    unit: i18n.t('kpi.unit.GwHPerYear'),
    getValue: value => roundDecimals(12 - value * 5, 2),
  },
  healthProgram: {
    label: i18n.t('kpi.fields.healthService'),
    unit: i18n.t('kpi.unit.euroPerEmployee'),
    getValue: value => roundDecimals(2000 + value * 4000),
  },
  innovation: {
    label: i18n.t('kpi.fields.innovationRate'),
    unit: i18n.t('ui.symbol.percentage'),
    getValue: value => roundDecimals(60 + value * 35, 1),
  },
  plastic: {
    label: i18n.t('kpi.fields.totalPlasticWaste'),
    unit: i18n.t('kpi.unit.tonsPerYear'),
    getValue: value => roundDecimals(7000 - value * 4000),
  },
  revenue: {
    label: i18n.t('kpi.fields.netProfit'),
    unit: i18n.t('kpi.unit.euroMillions'),
    getValue: value => roundDecimals(20 + value * 60, 1),
  },
  training: {
    label: i18n.t('kpi.fields.trainingBudget'),
    unit: i18n.t('kpi.unit.euroPerEmployee'),
    getValue: value => roundDecimals(1000 + value * 5000),
  },
});
